module.exports = __webpack_public_path__ + "img/y-205.c41557ee.png";